import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  createTestPageTitle: {
    fontFamily: 'Poppins',
    fontSize: 36,
    fontStyle: 'normal',
    fontWeight: 700,
  },
}));
